export default {"src":"/_next/static/media/nuki-logo-white.97666df5.svg","height":63,"width":100,"blurWidth":0,"blurHeight":0};